var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMic = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  color: "currentColor",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.834 5.833a4.167 4.167 0 1 1 8.333 0v3.75a4.167 4.167 0 0 1-8.333 0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m16.303 12.334.25-.573-1.145-.5-.25.572a5.627 5.627 0 0 1-10.315 0l-.25-.572-1.146.5.25.573a6.88 6.88 0 0 0 5.678 4.096v1.903h1.25V16.43a6.88 6.88 0 0 0 5.678-4.096"
})));
export default SvgMic;